.root {
  .header {
    padding: 1rem 1.5rem;

    .title {
      color: var(--mantine-color-primary-7);
      font-weight: 600;
      font-size: 1.25rem;
    }
  }

  .body {
    padding: 1.5rem;
  }
}
